import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { MarkerEvent } from './MarkerEvent';

var debug = require('debug')('CRATE:Communication:MarkerManager:CaretManger');

export var CaretManager =
/*#__PURE__*/
function (_MarkerEvent) {
  _inherits(CaretManager, _MarkerEvent);

  function CaretManager(opts) {
    var _this;

    _classCallCheck(this, CaretManager);

    var EventName = opts.EventName || 'Caret';
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CaretManager).call(this, _objectSpread({
      EventName: EventName
    }, opts)));
    _this._defaultOptions = {
      lifeTime: 5 * 1000,
      cursor: true
    };
    return _this;
  }
  /**
   * [caretMoved description]
   * @param  {[type]} range [description]
   * @return {[type]}       [description]
   */


  _createClass(CaretManager, [{
    key: "caretMoved",
    value: function caretMoved(range) {
      this.broadcast({
        range: range,
        id: this._document.uid
      });
      return range;
    }
  }, {
    key: "receive",

    /**
     *  At the reception of CARET position
     * @param  {[type]} range  [description]
     * @param  {[type]} id [description]
     * @return {[type]}        [description]
     */
    value: function receive(_ref) {
      var range = _ref.range,
          id = _ref.id;
      this.emit('Caret_received', {
        range: range,
        id: id
      });
    }
  }]);

  return CaretManager;
}(MarkerEvent);